import Head from 'next/head';

export default function HeadViewport() {
  return (
    <Head>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=5, interactive-widget=overlays-content"
      />
    </Head>
  );
}
